import React from 'react';
import cx from 'classnames';

import iconAccessibility from '../utils/iconAccessibility';
import styles from './Icons.module.scss';

export interface Props {
  accessibilityLabel?: string;
  className?: Parameters<typeof cx>[0];
}

export const ChevronRightS2: React.FC<Props> = ({
  accessibilityLabel,
  className,
}) => (
  <i className={cx(styles.icon, className)}>
    <svg
      width={24}
      height={24}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...iconAccessibility(accessibilityLabel)}
    >
      <path
        d='M11.02 15.01l3-3-3-3'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeMiterlimit={10}
      />
    </svg>
  </i>
);

ChevronRightS2.displayName = 'ChevronRightS2';
export default ChevronRightS2;
